import { render, staticRenderFns } from "./color-picker.vue?vue&type=template&id=49fb4f84&scoped=true&"
import script from "./color-picker.vue?vue&type=script&lang=js&"
export * from "./color-picker.vue?vue&type=script&lang=js&"
import style0 from "./color-picker.vue?vue&type=style&index=0&id=49fb4f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fb4f84",
  null
  
)

export default component.exports